<template>
  <layout-main-inner title="批次管理">
    <layout-card-wrap :hasSlot="true">
      <template slot="form">
        <!-- <ent-auto-select
          v-model="config.vendorId"
          style="margin-right: 10px"
          :callback="()=> { handleCurrentChange(1) }" /> -->
        <el-input
          v-model="config.batchCode"
          clearable
          style="width: 240px"
          placeholder="请输入批次号"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="批次号"
          width="160"
          prop="batchCode"> </el-table-column>
        <el-table-column
          label="商品名称"
          min-width="140"
          prop="productName"> </el-table-column>
        <el-table-column
          label="企业名称"
          min-width="200"
          prop="vendorName">
        </el-table-column>
        <el-table-column
          label="起止序号"
          width="170">
          <template slot-scope="{ row }">
            {{ row.beginTagNo | tagCount() }} - {{ row.endTagNo | tagCount() }}
          </template>
        </el-table-column>
        <el-table-column
          label="商品数量"
          width="100"
          prop="goodsCount">
        </el-table-column>
        <el-table-column
          label="建批模式"
          width="90">
          <template slot-scope="{row}">
            {{ row.tagModel | tagModel() }}
          </template>
        </el-table-column>
        <el-table-column
          key="8"
          label="备案时间"
          width="140"
          prop="createdTime">
          <template slot-scope="{ row }">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="permission.LVL2"
          label="操作"
          width="90">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.status !== 9"
              type="danger"
              @click="recall(row)">
              召回
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
// import EntAutoSelect from '../../components/ent-auto-select.vue'
export default {
  name: 'ScmBatchs',
  components: { },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        batchCode: '',
        vendorId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    recall(row) {
      this.$prompt('请输入紧急召回原因', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '紧急召回原因不能为空'
      }).then(({ value }) => {
        this.loading = true
        this.$store.dispatch('inspect/recallinspectreport', {
          payload: {
            vendorId: row.vendorId,
            inspectReportId: row.inspectReportId,
            batchIds: [row.batchId],
            memo: value
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('zs/getbatchs', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
